import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/constants/images";

const ICONS = ["fa-jet-fighter-up", "fa-shield-halved", "fa-cubes-stacked", "fa-industry"];

export default function Industries() {
  const { t } = useLang();
  const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7"];

  return (
    <section id="industries" className="border-t border-white/10 bg-navy/30 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeader eyebrow={t.industries.eyebrow} title={t.industries.title} />

        <div className="mt-14 grid gap-4 lg:grid-cols-12">
          {t.industries.items.map((item, i) => (
            <Reveal
              key={item.id}
              delay={i * 0.08}
              className={`${spans[i]} group relative h-[380px] overflow-hidden border border-white/10 lg:h-[440px]`}
              testid={`industry-card-${item.id}`}
            >
              <img
                src={IMAGES.industries[i]}
                alt={item.name}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                data-testid={`industry-image-${item.id}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-ink/10" />

              <div className="absolute right-4 top-4 border border-white/15 bg-ink/80 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-steel backdrop-blur">
                <i className="fa-solid fa-crosshairs mr-2 text-crimson" />
                {item.stat}
              </div>

              <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                <i className={`fa-solid ${ICONS[i]} mb-4 text-xl text-crimson`} />
                <h3 className="font-display text-2xl font-semibold uppercase leading-tight text-white sm:text-3xl">
                  {item.name}
                </h3>
                <p className="mt-2 text-sm font-medium text-steel">{item.highlight}</p>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-slate-300">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
